<template>
  <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.4632 0L12.2805 0L18.8223 8.215L12.2805 16.43L14.4632 16.43L21.005 8.215L14.4632 0Z" fill="currentColor"/>
    <path d="M18.8223 9.25098L0.717226 9.25098L0.717226 7.26804L18.8223 7.26804L18.8223 9.25098Z" fill="currentColor"/>
  </svg>
</template>
